var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "16 11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4355 44H26.7197V36.5645L26.7461 35.3428L26.79 34.0068C26.3389 34.458 26.0254 34.7539 25.8496 34.8945L24.373 36.0811L23.0635 34.4463L27.2031 31.1504H29.4355V44ZM41.916 37.5752C41.916 39.8193 41.5469 41.4805 40.8086 42.5586C40.0762 43.6367 38.9453 44.1758 37.416 44.1758C35.9336 44.1758 34.8145 43.6191 34.0586 42.5059C33.3086 41.3926 32.9336 39.749 32.9336 37.5752C32.9336 35.3076 33.2998 33.6377 34.0322 32.5654C34.7646 31.4873 35.8926 30.9482 37.416 30.9482C38.8984 30.9482 40.0176 31.5107 40.7734 32.6357C41.5352 33.7607 41.916 35.4072 41.916 37.5752ZM35.6318 37.5752C35.6318 39.1514 35.7666 40.2822 36.0361 40.9678C36.3115 41.6475 36.7715 41.9873 37.416 41.9873C38.0488 41.9873 38.5059 41.6416 38.7871 40.9502C39.0684 40.2588 39.209 39.1338 39.209 37.5752C39.209 35.999 39.0654 34.8682 38.7783 34.1826C38.4971 33.4912 38.043 33.1455 37.416 33.1455C36.7773 33.1455 36.3203 33.4912 36.0449 34.1826C35.7695 34.8682 35.6318 35.999 35.6318 37.5752ZM52.1992 37.5752C52.1992 39.8193 51.8301 41.4805 51.0918 42.5586C50.3594 43.6367 49.2285 44.1758 47.6992 44.1758C46.2168 44.1758 45.0977 43.6191 44.3418 42.5059C43.5918 41.3926 43.2168 39.749 43.2168 37.5752C43.2168 35.3076 43.583 33.6377 44.3154 32.5654C45.0479 31.4873 46.1758 30.9482 47.6992 30.9482C49.1816 30.9482 50.3008 31.5107 51.0566 32.6357C51.8184 33.7607 52.1992 35.4072 52.1992 37.5752ZM45.915 37.5752C45.915 39.1514 46.0498 40.2822 46.3193 40.9678C46.5947 41.6475 47.0547 41.9873 47.6992 41.9873C48.332 41.9873 48.7891 41.6416 49.0703 40.9502C49.3516 40.2588 49.4922 39.1338 49.4922 37.5752C49.4922 35.999 49.3486 34.8682 49.0615 34.1826C48.7803 33.4912 48.3262 33.1455 47.6992 33.1455C47.0605 33.1455 46.6035 33.4912 46.3281 34.1826C46.0527 34.8682 45.915 35.999 45.915 37.5752Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#21B152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip100);
export default __webpack_public_path__ + "static/media/chip100.58218736296b0919e424e8893d97d7da.svg";
export { ForwardRef as ReactComponent };